import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export const Skeleton = ({ className, ...props }: ComponentProps<'div'>) => {
  return (
    <div
      data-slot="skeleton"
      className={cn('skeleton-shimmer relative overflow-hidden rounded-md', className ?? '')}
      {...props}
    />
  );
};
